<template>
  <router-view></router-view>
</template>

<script>
  export default {
    name: 'App',
  };
</script>



// WEBPACK FOOTER //
// app/javascript/packs/auctions_catalogs/show/components/app.vue?4b8de2a4